var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/","aria-label":"Front"}},[_c('img',{staticClass:"navbar-brand-logo",attrs:{"src":_vm.$store.state.url + '/logo.jpg',"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }